
























































































import { defineComponent, ref, computed } from '@vue/composition-api';
import { i18n } from './../../i18n';
import Identity from './index';
import { PostAuthorizeForm, PreviewVideoInfo } from './types';
import { trackEvent } from './../../utils/index';
const name = 'ttam-identity-post-authorize-compose';

export default defineComponent({
  name,
  components: {
    TtamIdentityTiktokPostAuthorizeButton: Identity.TtamIdentityTiktokPostAuthorizeButton,
    TtamIdentityTiktokPostAuthorizeGuide: Identity.TtamIdentityTiktokPostAuthorizeGuide,
    TtamIdentityTiktokPostAuthorizeCodeDisplay: Identity.TtamIdentityTiktokPostAuthorizeCodeDisplay,
    TtamIdentityTiktokPostAuthorizeSearchInput: Identity.TtamIdentityTiktokPostAuthorizeSearchInput,
    TtamIdentityTiktokPostAuthorizePreview: Identity.TtamIdentityTiktokPostAuthorizePreview,
  },
  props: {
    showTips: {
      type: Boolean,
      default: false,
    },
    smbTea: {
      type: Object,
      required: false,
    },
    ifButton: {
      type: Boolean,
      default: false,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const formRef = ref(null);
    const isFetchedVideoSuccess = ref(false);
    const formData = ref<PostAuthorizeForm>({
      videoCode: '',
      fromVideoCode: '',
    });
    const { videoCodeValidator, fromVideoCodeValidator } = Identity.usePostAuthorizeRules();
    const dialogVisible = ref(false);

    const {
      run: getAuthorizeVideo,
      data: authorizeVideoData,
      isLoading: authorizeVideoLoading,
      error: authorizeError,
      reset: resetAuthorizeVideoStatus,
    } = Identity.usePostAuthorizeDataSource({
      params: formData,
    });
    const authorizeErrorTips = computed(() => {
      if (authorizeVideoData.value?.ttVideo?.isMultiDuetStitch) {
        return i18n.t('module_library_native_video_link_is_multi_duet_stitch');
      } else {
        return (authorizeError.value as any)?.response?.data?.msg;
      }
    });
    const needDoubleAuthorize = computed(() => Boolean(authorizeVideoData.value?.ttVideo?.fromItemId));

    const videoUrl = ref('');
    const onSearchAuthorizeVideo = async (val: string) => {
      formData.value.videoCode = val;
      isFetchedVideoSuccess.value = false;
      resetAuthorizeVideoStatus();
      await getAuthorizeVideo();
      isFetchedVideoSuccess.value = !authorizeErrorTips.value && !needDoubleAuthorize.value;
      videoUrl.value = authorizeVideoData.value?.ttVideo?.videoInfo?.playUrl;
    };

    const videoInfo = computed<PreviewVideoInfo>(() => {
      const video = authorizeVideoData.value?.ttVideo;
      const vInfo = video?.videoInfo;
      return {
        nickName: video?.nickName,
        text: video?.text,
        coreUserId: video?.coreUserId,
        duration: vInfo?.duration ?? 0,
        resolution: `${vInfo?.width ?? 0}x${vInfo?.height ?? 0}`,
        fileSize: vInfo?.fileSize,
        bitrate: vInfo?.bitrate,
        avatar: video?.avatarIcon?.url,
        url: videoUrl.value,
        poster: vInfo?.coverUrl,
        anchor: video?.anchors?.[0]?.title,
      };
    });

    const {
      run: getDoubleAuthorizeData,
      isLoading: doubleAuthorizeLoading,
      error: doubleAuthorizeError,
      reset: resetDoubleAuthorizeStatus,
    } = Identity.usePostAuthorizeDoubleDataSource({
      params: formData,
    });

    const doubleAuthorizeErrorTips = computed(() => (doubleAuthorizeError.value as any)?.response?.data?.msg);
    const isGetDoubleAuthorizeVideoSuccess = computed(
      () => !doubleAuthorizeError.value && formData.value.fromVideoCode,
    );

    const onSearchDoubleAuthorizeVideo = async (val: string) => {
      formData.value.fromVideoCode = val;
      resetDoubleAuthorizeStatus();
      await getDoubleAuthorizeData();
      isFetchedVideoSuccess.value = !doubleAuthorizeErrorTips.value;
    };
    const { submit, isLoading: isSubmittng } = Identity.usePostAuthorizeSubmit({
      params: formData,
      needDoubleAuthorize,
    });
    const onCodeClear = () => {
      formData.value = {
        videoCode: '',
        fromVideoCode: '',
      };
      isFetchedVideoSuccess.value = false;
      resetAuthorizeVideoStatus();
      resetDoubleAuthorizeStatus();
    };

    const onAdd = () => {
      dialogVisible.value = true;
    };
    const onClose = () => {
      try {
        trackEvent('close_apply_for_authorization');
      } catch (e) {
        console.error(e);
      }
      onCodeClear();
      dialogVisible.value = false;
    };

    const onSubmit = () => {
      formRef.value?.validate(async (isValid: boolean) => {
        if (isValid) {
          await submit();
          const id = authorizeVideoData.value?.ttVideo?.coreUserId;
          emit('confirm');
          emit('authVideo', { id });
          try {
            trackEvent('upgrade_identity_tta_tab_authorize_success');
          } catch (e) {
            console.error(e);
          }
          onClose();
        }
      });
    };
    const handleAuthVideoTeaReport = e => {
      emit('search-auth-video', e);
    };
    return {
      name,
      formRef,
      formData,
      videoInfo,
      isSubmittng,
      dialogVisible,
      videoCodeValidator,
      authorizeErrorTips,
      authorizeVideoData,
      needDoubleAuthorize,
      isFetchedVideoSuccess,
      authorizeVideoLoading,
      fromVideoCodeValidator,
      doubleAuthorizeLoading,
      doubleAuthorizeErrorTips,
      handleAuthVideoTeaReport,
      isGetDoubleAuthorizeVideoSuccess,
      onAdd,
      onClose,
      onSubmit,
      onCodeClear,
      onSearchAuthorizeVideo,
      onSearchDoubleAuthorizeVideo,
    };
  },
});
